export default {
    message: 'The {_field_} value must be a valid phone number.',
    validate: (value) => {
        let regex = /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/;
        return regex.test(value);
    }
}
